import { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";

const navItems = [
  { to: "/", label: "模型总览", match: (path: string) => path === "/" },
  { to: "/datasets", label: "数据加载", match: (path: string) => path.startsWith("/datasets") },
  {
    to: "/model/model-city/settings",
    label: "模型设置",
    match: (path: string) => path.startsWith("/model"),
  },
  { to: "/results", label: "打标结果", match: (path: string) => path.startsWith("/results") },
];

export default function AppHeader() {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const handleLogout = () => {
    localStorage.removeItem("atr_logged_in");
    localStorage.removeItem("atr_user");
    navigate("/login");
  };

  return (
    <header className="sticky top-0 z-40 w-full border-b border-background-200 bg-background-50">
      <div className="flex h-16 w-full items-center px-4 md:px-8">
        <button
          type="button"
          onClick={() => navigate("/")}
          className="flex cursor-pointer items-center gap-2.5"
        >
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent-500 text-background-50">
            <i className="ri-price-tag-3-fill text-lg" />
          </span>
          <span className="text-lg font-semibold tracking-tight text-foreground-950">
            文章智能打标
          </span>
        </button>

        <nav className="ml-10 hidden items-center gap-1 md:flex">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                [
                  "whitespace-nowrap rounded-md px-3.5 py-2 text-sm font-medium transition-colors",
                  isActive
                    ? "bg-primary-50 text-primary-700"
                    : "text-foreground-600 hover:bg-background-100 hover:text-foreground-950",
                ].join(" ")
              }
              end={item.to === "/"}
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="ml-auto flex items-center gap-4">
          <span className="hidden text-sm text-foreground-600 md:block">
            您好，<span className="font-medium text-foreground-950">admin</span>
          </span>
          <button
            type="button"
            onClick={handleLogout}
            className="hidden cursor-pointer items-center gap-1.5 rounded-md border border-background-300 px-3 py-1.5 text-sm text-foreground-700 transition-colors hover:bg-background-100 md:flex"
          >
            <i className="ri-logout-box-r-line" />
            退出登录
          </button>
          <button
            type="button"
            onClick={() => setMenuOpen((prev) => !prev)}
            className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md border border-background-300 text-foreground-800 md:hidden"
            aria-label="菜单"
          >
            <i className={menuOpen ? "ri-close-line text-lg" : "ri-menu-line text-lg"} />
          </button>
        </div>
      </div>

      {menuOpen ? (
        <div className="border-t border-background-200 bg-background-50 px-4 py-3 md:hidden">
          <nav className="flex flex-col gap-1">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                onClick={() => setMenuOpen(false)}
                end={item.to === "/"}
                className={({ isActive }) =>
                  [
                    "rounded-md px-3 py-2 text-sm font-medium",
                    isActive
                      ? "bg-primary-50 text-primary-700"
                      : "text-foreground-600 hover:bg-background-100",
                  ].join(" ")
                }
              >
                {item.label}
              </NavLink>
            ))}
            <button
              type="button"
              onClick={handleLogout}
              className="mt-1 cursor-pointer rounded-md px-3 py-2 text-left text-sm font-medium text-foreground-600 hover:bg-background-100"
            >
              退出登录
            </button>
          </nav>
        </div>
      ) : null}
    </header>
  );
}